/*
 * Priority Order Processing checkbox (order-process.liquid).
 *
 * Adds/removes settings.order_process_product from the cart when the user
 * toggles the checkbox in the cart drawer, then re-renders the drawer using
 * the same section-rendering flow the theme's product-form / cart-items use.
 *
 * Uses event delegation on document so it keeps working after the drawer
 * re-renders (which replaces the .order_process element with a fresh one
 * whose checked state reflects the server-side cart).
 */
(function () {
  if (window.__orderProcessBound) return;
  window.__orderProcessBound = true;

  document.addEventListener('change', function (event) {
    const checkbox = event.target.closest && event.target.closest('#order_process_product');
    if (!checkbox) return;

    const wrap = checkbox.closest('.order_process');
    if (!wrap) return;

    const variantId = parseInt(wrap.getAttribute('data-product-value'), 10);
    if (!variantId) {
      console.error('[order_process] missing/invalid data-product-value');
      return;
    }

    const cartDrawer = document.querySelector('cart-drawer');
    if (!cartDrawer || typeof cartDrawer.renderContents !== 'function') {
      console.error('[order_process] cart-drawer element not available');
      return;
    }

    // Prevent double submits and show the loading overlay.
    checkbox.disabled = true;
    wrap.classList.add('is-loading');

    const sections = cartDrawer.getSectionsToRender().map(function (section) {
      return section.id;
    });
    const sectionsUrl = window.location.pathname;

    let request;
    if (checkbox.checked) {
      const body = JSON.stringify({
        id: variantId,
        quantity: 1,
        sections: sections,
        sections_url: sectionsUrl,
      });
      request = fetch(window.routes.cart_add_url, Object.assign(fetchConfig(), { body: body }));
    } else {
      // change.js requires `id` as a String (variant id or line key) — a JSON
      // number is rejected with a 400. The priority product is added plainly
      // (no line properties) so the variant id resolves deterministically.
      const body = JSON.stringify({
        id: String(variantId),
        quantity: 0,
        sections: sections,
        sections_url: sectionsUrl,
      });
      request = fetch(window.routes.cart_change_url, Object.assign(fetchConfig(), { body: body }));
    }

    request
      .then(function (response) {
        return response.json();
      })
      .then(function (state) {
        // add.js signals errors via `status`; change.js via `errors`.
        if (state.status || state.errors) {
          console.error('[order_process]', state.description || state.errors || state.message);
          // Revert the checkbox so the UI doesn't misrepresent the cart.
          checkbox.checked = !checkbox.checked;
          checkbox.disabled = false;
          wrap.classList.remove('is-loading');
          return;
        }
        // Re-render the drawer (and cart icon bubble). This replaces the
        // .order_process element, so its checked/disabled state is reset
        // from the freshly rendered server markup.
        cartDrawer.renderContents(state);
      })
      .catch(function (error) {
        console.error('[order_process]', error);
        checkbox.checked = !checkbox.checked;
        checkbox.disabled = false;
        wrap.classList.remove('is-loading');
      });
  });
})();
